import { useMutation } from '@tanstack/react-query';
import { policiesService } from '../../../services/policies';
import { downloadBlob } from '../../../shared/utils/download-blob.util';

interface DownloadInstallmentParams {
  policyId: string;
  installmentNumber: number;
  /** Capital Global/Vida PME: o nº da parcela se repete entre subestipulantes. */
  subStipulatorNumber?: number | null;
}

export function useInstallmentPdf() {
  return useMutation({
    retry: false,
    mutationFn: async ({
      policyId,
      installmentNumber,
      subStipulatorNumber,
    }: DownloadInstallmentParams) => {
      const result = await policiesService.getInstallmentPDF(
        policyId,
        installmentNumber,
        subStipulatorNumber
      );

      if (!result.success || !result.data?.length) {
        throw new Error(result.error || 'Boleto ainda não disponível para esta parcela');
      }

      const pdf = result.data[0];
      const byteCharacters = atob(pdf.pdfBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      const subSuffix = subStipulatorNumber != null ? `-sub-${subStipulatorNumber}` : '';
      downloadBlob(blob, `boleto${subSuffix}-parcela-${pdf.number}.pdf`);
    },
  });
}
